import { trigger, state, style, animate, transition, keyframes } from '@angular/animations';

const trs = 180;

export function animAlocator(triggerName: string, transform: string) {
   return trigger(triggerName, [
      state('void', style({
         transform,
      })),
      transition(':enter, :leave', [
         animate(trs)
      ]),
   ]);
};

export const Drop = trigger('Drop', [
   transition(':enter', [
      style({ transform: 'rotateX(90deg)' }),
      animate(trs, style({ transform: 'rotateX(0)' }))
   ]),
   transition(':leave', [
      animate(trs, style({ transform: 'rotateX(90deg)' }))
   ])
]);

export const Slide = trigger('Slide', [
   transition(':enter', [
      style({ opacity: '0' }),
      animate(150, style({ opacity: '1' }))
   ]),
]);





export const Grow = animAlocator('Grow', 'scale(0)');
export const TopDrop = animAlocator('TopDrop', 'translateY(-100vh)');
export const LeftSlide = animAlocator('LeftSlide', 'translateX(-100vh)');


export const Fade = trigger(`Fade`, [
   state('void', style({
      transform: 'TranslateY(-2em)',
      opacity: '0',
   })),
   transition(':enter, :leave', [
      animate(trs)
   ]),
]);


// export const FadeIn = trigger(`FadeIn`, [
//    state('void', style({
//       transform: 'Translate(-1em, {{ y }})',
//       // opacity: '0.2',
//    })),
//    transition(':enter', [
//       animate('300ms ease-in')
//    ], { params: { y: "-1em" }}),
// ]);

export const FadeIn = trigger(`FadeIn`, [
   transition('* => bottom', [
      style({
         transform: 'Translate(-1em, -1em)',
         transformOrigin: 'top left'
      }),
      animate(`${trs}ms ease-in`)
   ]),
   transition('* => top', [
      style({
         transform: 'Translate(-1em, -1em)',
         transformOrigin: 'top left'
      }),
      animate(`${trs}ms ease-in`)
   ]),
]);

export const direction = isGoingDown => ({
   value: ':enter',
   params: {
      y: isGoingDown ? '-1em' : '1em'
   }
});

export const Selection = trigger('Selection', [
   state('selected', style({
      backgroundColor: 'green'
   })),
   transition('open => closed', [
      animate('1s')
   ]),
   transition('closed => open', [
      animate('0.5s')
   ]),
]);


export function animator(triggerName: string, styles: { [key: string]: string | number }) {
   return trigger(triggerName, [
      state('void', style(styles)),
      transition(':enter, :leave', [
         animate(trs)
      ]),
   ]);
};

export const ghost = animator(`ghost`, { 'opacity': 0 })